import * as yup from "yup";

export const validationSchema = yup.object().shape({
  temp_token: yup.string().required("کد ارسال شده را وارد کنید"),
});

export const initialValue = {
  temp_token: "",
};
